import {
  BookWidgetDateUpdateInfo,
  TripTypeOptions
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import { BookWidgetState } from '../../models/states/book-widget-state.interfaces';

export const updateBookWidgetDatesFn = (
  state: BookWidgetState,
  bookWidgetDateUpdateInfo: BookWidgetDateUpdateInfo
) => {
  const isMultiCity =
    state.fields.tripTypesField.selectedTripType === TripTypeOptions.MULTI_CITY;

  const updatedDatesField = [...state.fields.datesField.dates];
  updatedDatesField[bookWidgetDateUpdateInfo.flightIndex] =
    bookWidgetDateUpdateInfo.selectedRange;

  if (isMultiCity) {
    updateForwardDates(updatedDatesField, bookWidgetDateUpdateInfo);
  }

  return updatedDatesField;
};

// eslint-disable-next-line complexity
const updateForwardDates = (
  updatedDatesField: SelectedRange[],
  bookWidgetDateUpdateInfo: BookWidgetDateUpdateInfo
) => {
  const nextIndex = bookWidgetDateUpdateInfo.flightIndex + 1;
  const currentDate = bookWidgetDateUpdateInfo.selectedRange?.start;
  for (let i = nextIndex; i < updatedDatesField.length; i++) {
    const nextDate = updatedDatesField[i]?.start;
    if (currentDate && nextDate && currentDate < nextDate) {
      break;
    }
    if (!nextDate || (currentDate && currentDate > nextDate)) {
      updatedDatesField[i] = bookWidgetDateUpdateInfo.selectedRange;
    }
  }
};
